import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _72dc86c4 = () => interopDefault(import('../pages/activiteiten-trainingen/index.vue' /* webpackChunkName: "pages/activiteiten-trainingen/index" */))
const _03ef28a2 = () => interopDefault(import('../pages/clienttevredenheidsonderzoek.vue' /* webpackChunkName: "pages/clienttevredenheidsonderzoek" */))
const _d12392c0 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _1f3732d4 = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _06d38ab0 = () => interopDefault(import('../pages/inschrijvingen/index.vue' /* webpackChunkName: "pages/inschrijvingen/index" */))
const _2df4542c = () => interopDefault(import('../pages/lid-worden/index.vue' /* webpackChunkName: "pages/lid-worden/index" */))
const _5cab3244 = () => interopDefault(import('../pages/mentoring/index.vue' /* webpackChunkName: "pages/mentoring/index" */))
const _4b2d499d = () => interopDefault(import('../pages/mijn-profiel/index.vue' /* webpackChunkName: "pages/mijn-profiel/index" */))
const _f5e88b48 = () => interopDefault(import('../pages/opleiding-training-en-boekrecensies/index.vue' /* webpackChunkName: "pages/opleiding-training-en-boekrecensies/index" */))
const _69395395 = () => interopDefault(import('../pages/over-nvpa/index.vue' /* webpackChunkName: "pages/over-nvpa/index" */))
const _0c6a3016 = () => interopDefault(import('../pages/studenten-lidmaatschap/index.vue' /* webpackChunkName: "pages/studenten-lidmaatschap/index" */))
const _75d1d280 = () => interopDefault(import('../pages/van-en-voor-leden/index.vue' /* webpackChunkName: "pages/van-en-voor-leden/index" */))
const _e279f826 = () => interopDefault(import('../pages/waarom-lid-worden.vue' /* webpackChunkName: "pages/waarom-lid-worden" */))
const _2fd7d2de = () => interopDefault(import('../pages/wijzigingsverzoek-bevestiging.vue' /* webpackChunkName: "pages/wijzigingsverzoek-bevestiging" */))
const _f7ea8f98 = () => interopDefault(import('../pages/zoeken.vue' /* webpackChunkName: "pages/zoeken" */))
const _fa89b9a4 = () => interopDefault(import('../pages/zorgverzekering.vue' /* webpackChunkName: "pages/zorgverzekering" */))
const _52b31cf2 = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _70d13514 = () => interopDefault(import('../pages/mijn-profiel/activiteiten.vue' /* webpackChunkName: "pages/mijn-profiel/activiteiten" */))
const _6bf4ee42 = () => interopDefault(import('../pages/mijn-profiel/dashboard.vue' /* webpackChunkName: "pages/mijn-profiel/dashboard" */))
const _0029f449 = () => interopDefault(import('../pages/mijn-profiel/documenten.vue' /* webpackChunkName: "pages/mijn-profiel/documenten" */))
const _0fa3e49c = () => interopDefault(import('../pages/mijn-profiel/mijn-documenten.vue' /* webpackChunkName: "pages/mijn-profiel/mijn-documenten" */))
const _3e05709a = () => interopDefault(import('../pages/mijn-profiel/promotiemateriaal.vue' /* webpackChunkName: "pages/mijn-profiel/promotiemateriaal" */))
const _410c80d5 = () => interopDefault(import('../pages/mijn-profiel/scholing/index.vue' /* webpackChunkName: "pages/mijn-profiel/scholing/index" */))
const _c74de812 = () => interopDefault(import('../pages/mijn-profiel/vakgroep/index.vue' /* webpackChunkName: "pages/mijn-profiel/vakgroep/index" */))
const _49e24e8e = () => interopDefault(import('../pages/opleiding-training-en-boekrecensies/nieuw/index.vue' /* webpackChunkName: "pages/opleiding-training-en-boekrecensies/nieuw/index" */))
const _71b68ad2 = () => interopDefault(import('../pages/over-nvpa/nieuws/index.vue' /* webpackChunkName: "pages/over-nvpa/nieuws/index" */))
const _dacbbb64 = () => interopDefault(import('../pages/studenten-lidmaatschap/student-inschrijving/index.vue' /* webpackChunkName: "pages/studenten-lidmaatschap/student-inschrijving/index" */))
const _04680ffd = () => interopDefault(import('../pages/therapeut/vinden.vue' /* webpackChunkName: "pages/therapeut/vinden" */))
const _b5797446 = () => interopDefault(import('../pages/van-en-voor-leden/nieuw/index.vue' /* webpackChunkName: "pages/van-en-voor-leden/nieuw/index" */))
const _385486a5 = () => interopDefault(import('../pages/auth/password/reset/index.vue' /* webpackChunkName: "pages/auth/password/reset/index" */))
const _76f291b7 = () => interopDefault(import('../pages/mijn-profiel/scholing/uploaden.vue' /* webpackChunkName: "pages/mijn-profiel/scholing/uploaden" */))
const _5803e5b7 = () => interopDefault(import('../pages/auth/password/reset/_token.vue' /* webpackChunkName: "pages/auth/password/reset/_token" */))
const _fa9da86e = () => interopDefault(import('../pages/auth/invite/_token.vue' /* webpackChunkName: "pages/auth/invite/_token" */))
const _67201f4c = () => interopDefault(import('../pages/lid-worden/ideal/_id.vue' /* webpackChunkName: "pages/lid-worden/ideal/_id" */))
const _695f2940 = () => interopDefault(import('../pages/mijn-profiel/scholing/_id/index.vue' /* webpackChunkName: "pages/mijn-profiel/scholing/_id/index" */))
const _cabb2aa2 = () => interopDefault(import('../pages/mijn-profiel/vakgroep/_slug.vue' /* webpackChunkName: "pages/mijn-profiel/vakgroep/_slug" */))
const _7523cd62 = () => interopDefault(import('../pages/over-nvpa/nieuws/_slug.vue' /* webpackChunkName: "pages/over-nvpa/nieuws/_slug" */))
const _30914202 = () => interopDefault(import('../pages/activiteiten-trainingen/_slug/index.vue' /* webpackChunkName: "pages/activiteiten-trainingen/_slug/index" */))
const _7301c193 = () => interopDefault(import('../pages/inschrijvingen/_id/index.vue' /* webpackChunkName: "pages/inschrijvingen/_id/index" */))
const _bdb0fed2 = () => interopDefault(import('../pages/opleiding-training-en-boekrecensies/_slug/index.vue' /* webpackChunkName: "pages/opleiding-training-en-boekrecensies/_slug/index" */))
const _0ce7766f = () => interopDefault(import('../pages/therapeut/_slug.vue' /* webpackChunkName: "pages/therapeut/_slug" */))
const _6b5bedbb = () => interopDefault(import('../pages/van-en-voor-leden/_slug/index.vue' /* webpackChunkName: "pages/van-en-voor-leden/_slug/index" */))
const _4fbfee41 = () => interopDefault(import('../pages/opleiding-training-en-boekrecensies/_slug/bewerken/index.vue' /* webpackChunkName: "pages/opleiding-training-en-boekrecensies/_slug/bewerken/index" */))
const _5f8a099d = () => interopDefault(import('../pages/van-en-voor-leden/_slug/bewerken/index.vue' /* webpackChunkName: "pages/van-en-voor-leden/_slug/bewerken/index" */))
const _1a476c52 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _91e62d42 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/activiteiten-trainingen",
    component: _72dc86c4,
    pathToRegexpOptions: {"strict":true},
    name: "activiteiten-trainingen"
  }, {
    path: "/clienttevredenheidsonderzoek",
    component: _03ef28a2,
    pathToRegexpOptions: {"strict":true},
    name: "clienttevredenheidsonderzoek"
  }, {
    path: "/contact",
    component: _d12392c0,
    pathToRegexpOptions: {"strict":true},
    name: "contact"
  }, {
    path: "/faq",
    component: _1f3732d4,
    pathToRegexpOptions: {"strict":true},
    name: "faq"
  }, {
    path: "/inschrijvingen",
    component: _06d38ab0,
    pathToRegexpOptions: {"strict":true},
    name: "inschrijvingen"
  }, {
    path: "/lid-worden",
    component: _2df4542c,
    pathToRegexpOptions: {"strict":true},
    name: "lid-worden"
  }, {
    path: "/mentoring",
    component: _5cab3244,
    pathToRegexpOptions: {"strict":true},
    name: "mentoring"
  }, {
    path: "/mijn-profiel",
    component: _4b2d499d,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel"
  }, {
    path: "/opleiding-training-en-boekrecensies",
    component: _f5e88b48,
    pathToRegexpOptions: {"strict":true},
    name: "opleiding-training-en-boekrecensies"
  }, {
    path: "/over-nvpa",
    component: _69395395,
    pathToRegexpOptions: {"strict":true},
    name: "over-nvpa"
  }, {
    path: "/studenten-lidmaatschap",
    component: _0c6a3016,
    pathToRegexpOptions: {"strict":true},
    name: "studenten-lidmaatschap"
  }, {
    path: "/van-en-voor-leden",
    component: _75d1d280,
    pathToRegexpOptions: {"strict":true},
    name: "van-en-voor-leden"
  }, {
    path: "/waarom-lid-worden",
    component: _e279f826,
    pathToRegexpOptions: {"strict":true},
    name: "waarom-lid-worden"
  }, {
    path: "/wijzigingsverzoek-bevestiging",
    component: _2fd7d2de,
    pathToRegexpOptions: {"strict":true},
    name: "wijzigingsverzoek-bevestiging"
  }, {
    path: "/zoeken",
    component: _f7ea8f98,
    pathToRegexpOptions: {"strict":true},
    name: "zoeken"
  }, {
    path: "/zorgverzekering",
    component: _fa89b9a4,
    pathToRegexpOptions: {"strict":true},
    name: "zorgverzekering"
  }, {
    path: "/auth/login",
    component: _52b31cf2,
    pathToRegexpOptions: {"strict":true},
    name: "auth-login"
  }, {
    path: "/mijn-profiel/activiteiten",
    component: _70d13514,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-activiteiten"
  }, {
    path: "/mijn-profiel/dashboard",
    component: _6bf4ee42,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-dashboard"
  }, {
    path: "/mijn-profiel/documenten",
    component: _0029f449,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-documenten"
  }, {
    path: "/mijn-profiel/mijn-documenten",
    component: _0fa3e49c,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-mijn-documenten"
  }, {
    path: "/mijn-profiel/promotiemateriaal",
    component: _3e05709a,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-promotiemateriaal"
  }, {
    path: "/mijn-profiel/scholing",
    component: _410c80d5,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-scholing"
  }, {
    path: "/mijn-profiel/vakgroep",
    component: _c74de812,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-vakgroep"
  }, {
    path: "/opleiding-training-en-boekrecensies/nieuw",
    component: _49e24e8e,
    pathToRegexpOptions: {"strict":true},
    name: "opleiding-training-en-boekrecensies-nieuw"
  }, {
    path: "/over-nvpa/nieuws",
    component: _71b68ad2,
    pathToRegexpOptions: {"strict":true},
    name: "over-nvpa-nieuws"
  }, {
    path: "/studenten-lidmaatschap/student-inschrijving",
    component: _dacbbb64,
    pathToRegexpOptions: {"strict":true},
    name: "studenten-lidmaatschap-student-inschrijving"
  }, {
    path: "/therapeut/vinden",
    component: _04680ffd,
    pathToRegexpOptions: {"strict":true},
    name: "therapeut-vinden"
  }, {
    path: "/van-en-voor-leden/nieuw",
    component: _b5797446,
    pathToRegexpOptions: {"strict":true},
    name: "van-en-voor-leden-nieuw"
  }, {
    path: "/auth/password/reset",
    component: _385486a5,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset"
  }, {
    path: "/mijn-profiel/scholing/uploaden",
    component: _76f291b7,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-scholing-uploaden"
  }, {
    path: "/auth/password/reset/:token",
    component: _5803e5b7,
    pathToRegexpOptions: {"strict":true},
    name: "auth-password-reset-token"
  }, {
    path: "/auth/invite/:token?",
    component: _fa9da86e,
    pathToRegexpOptions: {"strict":true},
    name: "auth-invite-token"
  }, {
    path: "/lid-worden/ideal/:id",
    component: _67201f4c,
    pathToRegexpOptions: {"strict":true},
    name: "lid-worden-ideal-id"
  }, {
    path: "/mijn-profiel/scholing/:id",
    component: _695f2940,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-scholing-id"
  }, {
    path: "/mijn-profiel/vakgroep/:slug",
    component: _cabb2aa2,
    pathToRegexpOptions: {"strict":true},
    name: "mijn-profiel-vakgroep-slug"
  }, {
    path: "/over-nvpa/nieuws/:slug",
    component: _7523cd62,
    pathToRegexpOptions: {"strict":true},
    name: "over-nvpa-nieuws-slug"
  }, {
    path: "/activiteiten-trainingen/:slug",
    component: _30914202,
    pathToRegexpOptions: {"strict":true},
    name: "activiteiten-trainingen-slug"
  }, {
    path: "/inschrijvingen/:id",
    component: _7301c193,
    pathToRegexpOptions: {"strict":true},
    name: "inschrijvingen-id"
  }, {
    path: "/opleiding-training-en-boekrecensies/:slug",
    component: _bdb0fed2,
    pathToRegexpOptions: {"strict":true},
    name: "opleiding-training-en-boekrecensies-slug"
  }, {
    path: "/therapeut/:slug?",
    component: _0ce7766f,
    pathToRegexpOptions: {"strict":true},
    name: "therapeut-slug"
  }, {
    path: "/van-en-voor-leden/:slug",
    component: _6b5bedbb,
    pathToRegexpOptions: {"strict":true},
    name: "van-en-voor-leden-slug"
  }, {
    path: "/opleiding-training-en-boekrecensies/:slug?/bewerken",
    component: _4fbfee41,
    pathToRegexpOptions: {"strict":true},
    name: "opleiding-training-en-boekrecensies-slug-bewerken"
  }, {
    path: "/van-en-voor-leden/:slug?/bewerken",
    component: _5f8a099d,
    pathToRegexpOptions: {"strict":true},
    name: "van-en-voor-leden-slug-bewerken"
  }, {
    path: "/",
    component: _1a476c52,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/*",
    component: _91e62d42,
    pathToRegexpOptions: {"strict":true},
    name: "all"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
